import { LinePart } from "../types";

export const LinePartHelper = {
  getLength: (segment: LinePart) => segment.end - segment.start,
  getCenter: (segment: LinePart) => (segment.start + segment.end) / 2,
  flatten: (segments: LinePart[]) => segments.flatMap<number>((i) => [i.start, i.end]),
  isIntersecting: (a: LinePart, b: LinePart) => {
    return (
      (a.start <= b.start && b.start <= a.end) ||
      (a.start <= b.end && b.end <= a.end) ||
      (b.start <= a.start && a.start <= b.end) ||
      (b.start <= a.end && a.end <= b.end)
    );
  },
  areIntersecting: (a: LinePart[], b: LinePart[]) => {
    return a.some((i) => b.some((j) => LinePartHelper.isIntersecting(i, j)));
  },
};
